import React from "react";
import getReactAppKeys from "../../utils/getReactAppKeys";
import { Turnstile } from '@marsidev/react-turnstile';
import i18n from "../../services/translations/i18n";

interface Props {
    onSuccess : (token:string)=> void
}

const TurnstileFormElement:React.FC<Props> = ({onSuccess}) => {
    const clientKeys = getReactAppKeys();
    const REACT_APP_TURNSTILE_SITE_KEY = clientKeys.REACT_APP_TURNSTILE_SITE_KEY;
    const lang = i18n.language;
    return (<Turnstile options={{
        language: lang,
    }} siteKey={REACT_APP_TURNSTILE_SITE_KEY}  onSuccess={onSuccess} />);
}

export default TurnstileFormElement;